import {gsap} from "gsap";
import {Power4} from "gsap/gsap-core";

gsap.registerPlugin(Power4)

const MenuDropdown = {
    hideSelected: true,

    init(menu) {
        this.amount = '30%';

        menu.find('.dropdown').each((i, el) => {
            const li = $(el).closest('li');
            this.bind(li);
        })
    },

    bind(li) {

        li.unbind('mouseenter').mouseenter((evt) => {
            const li = $(evt.currentTarget);
            const selected = li.siblings('.selected');
            if (li.is('.selected') || window.innerWidth < 1000) return;

            this.show(li);

            if(!this.hideSelected) return;

            if (selected && selected.length) {
                this.hide(selected);
            }
        })

        li.unbind('mouseleave').mouseleave((evt) => {
            const el = $(evt.currentTarget);
            const selected = el.siblings('.selected');
            if (el.is('.selected') || window.innerWidth < 1000) return;

            this.hide(li);

            if(!this.hideSelected) return;

            setTimeout(() => {
                el.removeClass('hover');

                if (selected && selected.length) {
                    this.show(selected);
                }
            }, 400)
        })
    },

    show(li) {
        const dropdown = li.find('> ul.dropdown');
        let param = li.closest('[method="renderMenu"]').is('[type="horizontal"]') ? 'top' : 'left';
        param = dropdown.is('[level=2]') ? 'x' : param;

        gsap.fromTo(dropdown, {
                [param]: [this.amount], display: 'none'
            }, {
                [param]: '100%', display: 'flex', duration: 0.5, overwrite: true
            }
        );
        li.addClass('hover');
    },

    hide(li) {
        const dropdown = li.find('> ul.dropdown');
        let param = li.closest('[method="renderMenu"]').is('[type="horizontal"]') ? 'top' : 'left';
        param = dropdown.is('[level=2]') ? 'x' : param;

        gsap.fromTo(dropdown, {
            [param]: '100%', display: 'flex', duration: 0.5, overwrite: true
        }, {
            [param]: [this.amount], display: 'none'
        });
    },

}

export default MenuDropdown;